exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-table {\r\n    max-height: 350px;\r\n    overflow: auto;\r\n}\r\n\r\n.container-table th{\r\n    background-color: #E2E7EB;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/github/490/rec_ng_recibopago490v7/src/app/components/table-items/table-items.component.css
// module id = ../../../../../src/app/components/table-items/table-items.component.css
// module chunks = main